import { useLayoutEffect, useState } from 'react'
import _ from 'lodash'

const getISOWeekStart = (dateStr) => {
  if (!dateStr) return null
  const d = new Date(dateStr)
  if (isNaN(d.getTime())) return null
  const day = d.getUTCDay()
  const diff = (day === 0 ? -6 : 1) - day
  d.setUTCDate(d.getUTCDate() + diff)
  d.setUTCHours(0, 0, 0, 0)
  return d
}

const formatWeekLabel = (d) =>
  d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' })

// Returns the short month name if this ISO week contains the 1st of a month, else null
const getMonthLabel = (isoWeekStart) => {
  const weekStart = new Date(isoWeekStart)
  for (let i = 0; i < 7; i++) {
    const d = new Date(weekStart)
    d.setUTCDate(d.getUTCDate() + i)
    if (d.getUTCDate() === 1) {
      return d.toLocaleDateString('en-US', { month: 'short', timeZone: 'UTC' })
    }
  }
  return null
}

/**
 * Aggregate real tasks into weekly stacked buckets (completed + remaining).
 * Shows a blank chart when no tasks are present.
 */
const withRemaining = (raw) =>
  raw.map(d => ({
    ...d,
    completedTasks: d.completedTasks ?? 0,
    remaining: d.total - (d.completedTasks ?? 0),
  }))

export const useTaskVelocityData = (tasks) => {
  const [data, setData] = useState([])

  useLayoutEffect(() => {
    function compute() {
      if (!tasks.length) return

      const raw = Object.entries(
        _.groupBy(tasks, task => {
          const ws = getISOWeekStart(task.task_window_start)
          return ws ? ws.toISOString() : null
        })
      )
        .filter(([k]) => k !== 'null')
        .sort(([a], [b]) => new Date(a) - new Date(b))
        .map(([isoWeekStart, weekTasks]) => {
          const completed = weekTasks.filter(t => t.state === 'completed').length
          return {
            weekLabel: formatWeekLabel(new Date(isoWeekStart)),
            monthLabel: getMonthLabel(isoWeekStart),
            total: weekTasks.length,
            completedTasks: completed,
          }
        })

      setData(withRemaining(raw))
    }
    compute()
  }, [tasks])

  return data
}
